import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2 } from 'lucide-react';
export function FullScreenLoader({ message }) {
    return (_jsx("div", { className: "bg-background flex h-dvh items-center justify-center", children: _jsxs("div", { className: "flex flex-col items-center gap-4", children: [_jsx(Loader2, { className: "text-primary h-8 w-8 animate-spin" }), message && _jsx("p", { className: "text-muted-foreground text-sm", children: message })] }) }));
}
